import { createContext, useReducer, useContext } from "react";
import reducerFun from "./Reducers";

// import moduleName from '../components/useReducerState';
// context Creation
// provider
// cosumer  =====> useContext hook

const AppContext = createContext();

const initialValues = {
  isLoading: true,
  isLogin: false,
  isLogout: true,
  userPayload: {},
  roles: "",
  staffUN: "",
  ip: "",
  isEditRight: false,
  isDeleteRight: false,
};

const AppProvider = (props) => {
  // console.log("props.initialValues =====>",  props.initialValues);

  const [state, dispatch] = useReducer(reducerFun, initialValues);

  return <AppContext.Provider value={{ ...state, state, dispatch }}>{props.children}</AppContext.Provider>;
};

// create custom hook  by using 'use' keyword in prefix of the functionName
const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppProvider, useGlobalContext };
